import {SMS_FETCHED} from "./actionType";
import {Dispatch} from "redux";
import {api} from "../../../api/api";
import {Action} from "redux-actions";
import {OnFailure, OnSuccess} from "../actionHelpers";
import Sms from "../../../model/sms/Sms";

/**
 * Text messages fetched successful action.
 * @param {Sms[]} textMessages list of text messages.
 * @returns {Action<SMS_FETCHED>}
 */
export function textMessagesFetched(textMessages: Sms[]): Action<SMS_FETCHED> {
	return {type: SMS_FETCHED, payload: {textMessages}};
}

/**
 * Fetch all text messages.
 */
export function fetchTextMessages(onSuccess: OnSuccess, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.smsApi.fetchTextMessages().then((messages: Sms[]) => {
			dispatch(textMessagesFetched(messages));
			onSuccess();
		}).catch(onFailure);
	}
}